import { cva } from 'class-variance-authority';
import type { ReactNode } from 'react';

import { LoadingText } from '@/components/loaders';
import { cn } from '@/lib/utils';

import Markdown from './Markdown';

type LoadingProps = {
  type: 'loading';
  children: string;
};

type OtherProps = {
  type: 'ai' | 'user' | 'error';
  children: string;
};

type Props = (LoadingProps | OtherProps) & {
  className?: string;
};

const messageVariants = cva(['w-full rounded-xs md:w-[95%] lg:w-[90%]'], {
  variants: {
    type: {
      ai: 'self-end bg-aqua-400/30',
      user: 'self-start bg-gray-400',
      error: 'self-end bg-red-400/30',
      loading: 'self-end bg-aqua-400/30',
    },
  },
});

const AIMessage = ({ className, type, children }: Props) => {
  let content: ReactNode = children;
  if (type === 'ai') {
    content = <Markdown>{children}</Markdown>;
  } else if (type === 'loading') {
    content = <LoadingText label={children} />;
  }

  return (
    <div className={cn(messageVariants({ type }), className)}>
      <div className="overflow-x-auto px-6 py-4">{content}</div>
    </div>
  );
};

export default AIMessage;
